import React from 'react';
import { connect } from 'react-redux';
import './subscription.scss';
import Summary from '../../common/Subscription/Summary';
import Button from '../../common/Button/Button';
import history from 'hb-redux-store/history';
import { getSummary } from 'hb-redux-store/feature/subscription/subscription.action';
import Icon from '../../mweb/Icon/Icon';
import Drawer from '../../common/Drawer';
import { getSubscriptionRoute } from './subscription.routes';
import {
  setSubscriptionSummaryModal,
  showAddressListModal,
} from 'hb-redux-store/feature/modal/modal.action';

const SubscriptionSummary = props => {
  const { loading, summary, showSubscriptionSummary } = props;
  React.useEffect(() => {
    const subscriptionId = props.match?.params || props.subscriptionId;
    if (subscriptionId) {
      props.getSummary({ subscriptionNo: subscriptionId });
    }
  }, []);
  return (
    <Drawer
      title="Subscription Summary"
      placement="right"
      closable={true}
      onClose={() => {
        if (props.match?.path === getSubscriptionRoute('subscriptionSummary')) {
          history.replace(getSubscriptionRoute('ramadanSubscription'));
        }
        props.setSubscriptionSummaryModal(false);
      }}
      visible={showSubscriptionSummary}
      destroyOnClose={true}
      maskClosable={true}
      width={500}
      footer={
        summary ? (
          <div>
            <div className="subsc-summary--address-detail">
              <div className="subsc-summary--address-detail--address">
                <Icon
                  size={30}
                  class="icon-location-bar-location-marker flex-shrink-0"
                />
                <div className="subsc-summary--address-detail--primary-text ellipsis">
                  {summary?.deliveryAddress?.addressType ||
                    summary?.deliveryAddress?.area}
                </div>
                {summary?.completeAddressesList?.length > 0 && (
                  <Button
                    onClick={() => {
                      props.showAddressListModal(true);
                    }}
                    className="button action-link more flex-shrink-0"
                  >
                    Change
                  </Button>
                )}
              </div>
              <div className="subsc-summary--address-detail--secondary-text ellipsis">
                {summary?.deliveryAddress?.addressLine1 ||
                  summary?.deliveryAddress?.mapLocation ||
                  summary?.deliveryAddress?.addressLine2}
              </div>
            </div>
            <Button
              type="submit"
              className="button button-secondary full-width large"
              onClick={() => {
                history.push(getSubscriptionRoute('payment'));
              }}
              disabled={loading}
            >
              Subscribe & Pay
            </Button>
          </div>
        ) : (
          false
        )
      }
    >
      <Summary summary={props.summary} />
    </Drawer>
  );
};

const mapStatetoProps = ({ subscriptionReducer, modalReducer }) => {
  return {
    loading: subscriptionReducer.loading,
    summary: subscriptionReducer.summary,
    subscriptionId: subscriptionReducer.subscriptionId,
    showSubscriptionSummary: modalReducer.showSubscriptionSummary,
  };
};

const mapDispatchToProps = {
  getSummary,
  setSubscriptionSummaryModal,
  showAddressListModal,
};

export default connect(
  mapStatetoProps,
  mapDispatchToProps
)(SubscriptionSummary);
